import { EditAction } from '../shared/enum/EditAction';

export interface VehicleIpmModel {
    id: number,
    vehicleId: number,
    ipmValue: number | null,
    startOfPeriod: Date | null,
    endOfPeriod: Date | null,
    editAction: EditAction,
    userId: number
}

export const vehicleIpmModelInitial: VehicleIpmModel = {
    id: 0,
    vehicleId: 0,
    ipmValue: null,
    startOfPeriod: null,
    endOfPeriod: null,
    editAction: EditAction.NONE,
    userId: 0
};